import React, { useContext, useEffect, useState } from 'react';
import * as ClientApi from '~/lib/ClientApi';
import Modal from '~/components/Modal';
import Loading from '~/components/Loading';
import { formatDateShort, formatDateTime } from '~/lib/DateTime';
import { useClientHistoryQuery } from '~/public/lib/PublicQueries';
import SectionPicker from '~/components/SectionPicker';
import EventDateAndTime from '~/components/calendar/EventDateAndTime.jsx';
import StartEndDateTime from '~/components/forms/StartEndDateTime.jsx';
import ThemedForm from '~/components/forms/ThemedForm.jsx';
import { FormContext } from '~/components/forms/FormContext.jsx';
import { StatusBadge } from '~/components/packages/GrantList.jsx';
import { humanGrantRedeemableAmount } from '~/lib/PackageHelpers.js';
import SubscriptionHistory from '~/components/forms/questions/components/ClientAccount/SubscriptionHistory';
import PackageHistory from '~/components/forms/questions/components/ClientAccount/PackageHistory';
import EventHistory from '~/components/forms/questions/components/ClientAccount/EventHistory';
import ClientAccountBilling from '~/components/forms/questions/components/ClientAccount/ClientAccountBilling';
import ThemedModal from '~/components/ThemedModal';
import WaitlistHistory from '~/components/forms/questions/components/ClientAccount/WaitlistHistory';

const ClientHistory = ({ history, refetch, client, allClients }) => {
    const [section, setSection] = useState('appointments');
    const navOptions = [
        { label: 'Appointments', value: 'appointments' },
        { label: 'Packages', value: 'packages' },
    ];

    if (history?.subscriptions?.length > 0) {
        navOptions.push({
            label: 'Subscriptions',
            value: 'subscriptions',
        });
    }

    if (history?.waitlist?.length > 0) {
        navOptions.push({
            label: 'Waitlist',
            value: 'waitlist',
        });
    }

    navOptions.push({ label: 'Billing', value: 'billing' });

    return (
        <div>
            <SectionPicker
                options={navOptions}
                value={section}
                onChange={setSection}
                className="mb-4"
            />

            {section === 'appointments' && (
                <EventHistory events={history?.events || []} />
            )}

            {section === 'packages' && (
                <PackageHistory packages={history?.packages || []} />
            )}

            {section === 'subscriptions' && (
                <SubscriptionHistory packages={history?.subscriptions || []} />
            )}

            {section === 'waitlist' && (
                <WaitlistHistory waitlist={history?.waitlist || []} />
            )}

            {section === 'billing' && (
                <ClientAccountBilling
                    paymentMethods={history?.paymentMethods}
                    refetch={refetch}
                    client={client}
                />
            )}
        </div>
    );
};

const ClientAccountManageModal = ({
    isOpen,
    onClose,
    client,
    allClients,
    form,
}) => {
    const { data, isLoading, refetch } = useClientHistoryQuery();
    const history = data || {};

    return (
        <ThemedModal
            isOpen={isOpen}
            onClose={onClose}
            panelClassName="!bg-gray-100"
            widthClass="sm:max-w-[750px]"
        >
            <h2 className="mb-6">Manage Account</h2>
            {isLoading && <Loading />}
            {!isLoading && (
                <ClientHistory
                    history={history}
                    refetch={refetch}
                    allClients={allClients}
                    client={client}
                />
            )}
        </ThemedModal>
    );
};

export default ClientAccountManageModal;
